import React from "react";
import "../css/privacy.scss";

const faqs = [
  ["What makes tunrisefield paper pen-friendly?", "We select smooth, low-feathering paper and test it with fountain pens, rollerballs, gel pens, pencils, and markers."],
  ["When will my order ship?", "Most in-stock orders leave within one business day. Holiday periods and special-order items may require additional time."],
  ["Do you ship internationally?", "Yes. Available carriers and rates are shown at checkout. Customers are responsible for any destination-country duties or taxes."],
  ["Can I return an item?", "Unused and unopened merchandise may be returned within 14 days of delivery. Please read our Refund Policy before sending anything back."],
  ["How should I choose a notebook format?", "Choose blank pages for drawing, ruled pages for notes, dot grid for flexible layouts, and grid pages for diagrams or structured writing."],
  ["How can I contact you?", "Email mall@tunrisefield.xyz. We aim to reply within two business days."],
];

function Faq() {
  return (
    <main className="page-width page-width--narrow section-template--19439205515429__main-padding">
      <h1 className="main-page-title page-title h0">faqs</h1>
      <div className="rte">
        {faqs.map(([question, answer]) => (
          <section key={question}>
            <h2>{question}</h2>
            <p>{answer}</p>
          </section>
        ))}
      </div>
    </main>
  );
}

export default Faq;
